import { Optional } from '../Common/interfaces';
import { CheckmarkError, CheckmarkSuccess } from '../icons';
import {
    FormContext,
    getColorsForStatus,
    ValidationStatus,
} from './FormContext';
import { FormValidationMessage } from './FormValidationMessage';

type Props = {
    validationStatus: Optional<ValidationStatus>;
    validationText?: Optional<string>;
    children: React.ReactElement;
    className?: string;
};
export function FormValidation({
    validationStatus,
    validationText,
    children,
    className,
}: Props) {
    const colors = getColorsForStatus(validationStatus);
    return (
        <FormContext.Provider
            value={{ validationStatus, validationColors: colors }}
        >
            <div className={className}>
                <div className="relative">
                    {children}
                    {validationStatus === 'success' && (
                        <CheckmarkSuccess
                            className={'absolute right-10 ' + colors.textColor}
                            aria-hidden="true"
                        />
                    )}
                    {validationStatus === 'error' && (
                        <CheckmarkError
                            className={
                                'absolute right-10 top-1/2 -translate-y-1/2 ' +
                                colors.textColor
                            }
                            aria-hidden="true"
                        />
                    )}
                </div>
                {validationText && (
                    <FormValidationMessage validationStatus={validationStatus}>
                        {validationText}
                    </FormValidationMessage>
                )}
            </div>
        </FormContext.Provider>
    );
}
